import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';

const TabbingsAWBStock = ({ ae_mawb_url, ae_hawb_url, accessedPermission, tab_imp_exp, tab_air_sea }) => {

    // Define tab mapping (eventKey -> URL path)    
    const navigate = useNavigate();
    const location = useLocation();
    const tabRoutes = {
        mawb: ae_mawb_url,
        hawb: ae_hawb_url,
    };

    // Determine active tab from current URL
    const getActiveTab = () => {
        const foundKey = Object.keys(tabRoutes).find(key => location.pathname === tabRoutes[key]);
        return foundKey || "mawb"; // Default tab if not found
    };

    const [activeTab, setActiveTab] = useState(getActiveTab());

    // Update tab when location changes
    useEffect(() => {
        setActiveTab(getActiveTab());
    }, [location.pathname]);


    return (
        <>
            <div className="row-gap-2">
                <div className="tab-content" id="pills-tabContent">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => {
                            setActiveTab(k);
                            navigate(tabRoutes[k]); // Navigate to the corresponding route
                        }}
                        transition={false}
                        id="noanim-tab-example"
                        className="nav nav-pills mb-3 custom-tabs gap-0"
                    >
                        {
                            // (
                            //     (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_air_import_list")) ||
                            //     (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_air_export_list")) ||
                            //     (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_sea_import_list")) ||
                            //     (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_sea_export_list"))
                            // ) &&
                            <Tab eventKey="mawb" title="Master AWB Stock" className="nav-item" />}
                        {
                            // (
                            //     (tab_air_sea == "air" && tab_imp_exp == "import" && accessedPermission.includes("ff_ai_direct_shipment_list")) ||
                            //     (tab_air_sea == "air" && tab_imp_exp == "export" && accessedPermission.includes("ff_ae_direct_shipment_list")) ||
                            //     (tab_air_sea == "sea" && tab_imp_exp == "import" && accessedPermission.includes("ff_si_direct_shipment_list")) ||
                            //     (tab_air_sea == "sea" && tab_imp_exp == "export" && accessedPermission.includes("ff_se_direct_shipment_list"))
                            // ) &&
                            <Tab eventKey="hawb" title={`House AWB Stock`} className="nav-item" />}
                         </Tabs>
                </div>
            </div>
        </>
    )
}

export default TabbingsAWBStock